<template>
  <v-app-bar
    extension-height="24px"
    flat
    :color="ColorGray2"
    class="pHeader flex-grow-0"
  >
    <v-toolbar-title class="pt-1 pt-sm-2">
      <router-link to="/">
        <img
          class="sw-ImgContrast"
          alt="アルパカコネクト"
          :width="$vuetify.breakpoint.xsOnly ? '160px' : '231px'"
          src="~@/assets/logo.png"
        />
      </router-link>
    </v-toolbar-title>

    <v-toolbar-items
      v-if="($route.name != 'signup') & $vuetify.breakpoint.mdAndUp"
      class="wHeader-Nav ml-8 font-weight-bold fs-s"
    >
      <router-link to="/worldSelect" class="wHeader-Nav_Unit pa-5"
      >ワールド一覧
      </router-link
      >
      <router-link to="/tailor" class="wHeader-Nav_Unit pa-5"
      >アルパカテーラー
      </router-link
      >
    </v-toolbar-items>
    <v-spacer></v-spacer>
    <div>
      <template v-if="$vuetify.breakpoint.smAndUp">
        <v-menu
          v-model="searchMenu"
          offset-y　
          content-class="pHeader-Menu elevation-0 mt-1"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-on="on"
              v-model="search"
              :color="ColorText"
              background-color="#fff"
              class="sw-Search fs-s"
              clearable
              rounded
              filled
              dense
              hide-details
              placeholder="作品・クリエイター検索"
              prepend-inner-icon="search"
              @keydown.enter="goSearchResult"
            />
          </template>
          <v-list>
            <v-list-item
              class="px-8"
              dense
              @click="$refs.portalSearchDialog.open()"
            >
              <v-list-item-title class="fs-s">詳細検索</v-list-item-title>
            </v-list-item>
            <v-list-item class="px-8" dense :to="{ name: 'ordermade' }">
              <v-list-item-title class="fs-s"
              >テーラー商品一覧
              </v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>
      </template>

      <template v-else>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-on="on"
              height="32px"
              width="32px"
              @click="$refs.portalSearchDialog.open()"
            >
              <v-icon size="24px">search</v-icon>
            </v-btn>
          </template>
          <span>作品・クリエイター検索</span>
        </v-tooltip>
      </template>
    </div>

    <div>
      <template>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              height="32px"
              width="32px"
              class="ml-2 mr-3 font-weight-bold fs-m"
              icon
              href="https://support.alpaca-connect.com/hc/ja"
              target="_blank"
              rel="noopener noreferrer"
              v-on="on"
            >？
            </v-btn
            >
            <!-- <v-btn
              height="32px"
              width="32px"
              class="mx-4"
              x-large
              icon
              href="https://support.alpaca-connect.com/hc/ja"
              target="_blank"
              rel="noopener noreferrer"
              v-on="on"
            >
              <v-icon>help</v-icon>
            </v-btn>-->
          </template>
          <span>ヘルプ・お問い合わせ</span>
        </v-tooltip>
      </template>
    </div>
    <div v-if="$route.name != 'signup' && $route.name != 'authOver'">
      <template v-if="userId === null">
        <v-btn
          small
          class="fc-white font-weight-bold"
          :color="ColorPrimary"
          depressed
          to="/login"
        >
          <v-icon left>account_circle</v-icon>
          ログイン
        </v-btn>
      </template>
      <template v-else>
        <v-avatar size="40" v-if="loading" color="#fff">
          <v-progress-circular
            :color="ColorTextSub"
            indeterminate
            size="24"
            width="3"
          ></v-progress-circular>
        </v-avatar>
        <v-menu
          v-else
          :open-on-hover="$vuetify.breakpoint.smAndUp"
          bottom
          offset-y
          content-class="pHeader-Menu elevation-0 mt-1"
          transition="slide-y-transition"
          :close-delay="200"
        >
          <template v-slot:activator="{ on, attrs }">
            <div v-on="on" :v-bind="attrs">
              <v-badge
                color="primary"
                overlap
                :value="mailBadge"
                :content="mailBadge"
                bordered
              >
                <BaseIcon
                  size="32"
                  :itemId="userClassIcon"
                  :type="userClass == 'ms' ? 'master'
                 : userClass === 'admin' || userClass === 'pl' ? 'user'
                 : 'creator'"
                  :bgColor="userClassIcon ? '' : 'var(--gray-6)'"
                />
              </v-badge>
            </div>
          </template>
          <v-list width="320px">
            <!-- ユーザー名 -->
            <v-list-item class="fs-m font-weight-bold" :to="{ name: 'myPage' }">
              <v-list-item-title>
                {{ userName }}さん
                <div class="fs-xs fc-gray-6 font-weight-medium">
                  マイページを表示
                </div>
              </v-list-item-title>
            </v-list-item>

            <v-divider></v-divider>
            <template v-for="item in menuList">
              <v-list-item
                exact-active-class
                v-if="item.active.includes(userClass)"
                :key="item.params"
                dense
                :to="{ name: item.params }"
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </template>

            <v-divider></v-divider>

            <template v-for="(item, index) in classLists">
              <v-list-item
                v-if="item.name && !(lastUsedClass === index)"
                :key="index"
                dense
                @click="changeClass(index)"
              >
                <BaseIcon
                  size="32"
                  :itemId="item.icon"
                  :type="(index === 0 || item.title ==='管理者') ? 'user'
                  : index === 1 ? 'master' :'creator'"
                  bgColor="var(--gray-6)"
                />
                <v-container>
                  <v-list-item-title class="fs-xxs">{{
                      item.title
                    }}
                  </v-list-item-title>
                  <v-list-item-title class="font-weight-bold">{{
                      item.name
                    }}
                  </v-list-item-title>
                </v-container>
              </v-list-item>
            </template>
            <v-divider></v-divider>
            <v-list-item dense @click="signOut">
              <v-list-item-title>
                <v-icon small class="pr-4">exit_to_app</v-icon>
                ログアウト
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </div>
    <template
      v-slot:extension
      v-if="
        ($route.name != 'signup' && $route.name != 'authOver') &
        $vuetify.breakpoint.smAndDown
      "
    >
      <div class="wHeader-Nav font-weight-bold fs-xs mb-2">
        <router-link to="/worldSelect" class="wHeader-Nav_Unit pa-2 mr-2"
        >ワールド一覧
        </router-link
        >
        <router-link to="/tailor" class="wHeader-Nav_Unit pa-2"
        >アルパカテーラー
        </router-link
        >
      </div>
    </template>
    <PortalSearchDialog
      ref="portalSearchDialog"
      :screen="0"
      :keyword="keyword"
      :creatorKbn="creatorKbn"
      :tags="tags"
      :liked="liked"
      :opend="opend"
      :ocWorld="ocWorld"
      :ocItem="ocItem"
      :type="type"
    />

    <!-- エラーダイアログ -->
    <CommonDialog
      ref="errorDialog"
      title="ユーザー情報の取得に失敗しました"
      @alertDialogReturn="errorDialogReturn"
      text="繰り返し失敗をする場合は、アルパカコネクトまでお問い合わせください"
    ></CommonDialog>
  </v-app-bar>
</template>

<script>
import axios from "axios";
import "firebase/auth";
import PortalSearchDialog from "@/views/portalSearch/portalSearchDialog";
import CommonDialog from "@/components/CommonDialog";

export default {
  components: {
    PortalSearchDialog,
    CommonDialog,
  },
  name: "PortalHeader",
  inject: ["reload", "upload", 'getMailHistoryBadge'],
  data() {
    return {
      playerIcon: "",
      noticeLists: [],
      userIcon: "",
      userName: "",
      timer: "",
      loading: false,
      searchMenu: false,
      search: "",
      lastUsedClass: "",
      classLists: [
        {name: "", icon: "", creatorId: "", title: "プレイヤー"},
        {name: "", icon: "", creatorId: "", title: "マスター"},
        {name: "", icon: "", creatorId: "", title: "クリエイター（IL）"},
        {name: "", icon: "", creatorId: "", title: "クリエイター（VA）"},
        {name: "", icon: "", creatorId: "", title: "クリエイター（WR）"},
        {name: "", icon: "", creatorId: "", title: "管理者"},
      ],
      menuList: [
        {
          title: "承認・運営",
          params: "myPage-admin",
          active: ["admin"],
        },
        {
          title: "キャラクター管理",
          params: "myPage-character",
          active: ["admin", "il", "va", "wr", "pl", "ms"],
        },
        {
          title: "テーラー管理",
          params: "myPage-tailor",
          active: ["admin", "il", "va", "wr", "pl", "ms"],
        },
        {
          title: "シナリオ管理",
          params: "myPage-scenario",
          active: ["admin", "ms"],
        },
        {
          title: "コイン・ポイント",
          params: "myPage-coin",
          active: ["admin", "il", "va", "wr", "pl", "ms"],
        },
        {
          title: "アカウント管理",
          params: "myPage-account",
          active: ["admin", "il", "va", "wr", "pl", "ms"],
        },
      ],
    };
  },
  props: {
    keyword: {
      mode: String,
      required: false,
      default: "",
    },
    creatorKbn: {
      mode: Number,
      required: false,
      default: 0,
    },
    tags: {
      mode: Array,
      required: false,
    },
    liked: {
      mode: Boolean,
      default: false,
    },
    opend: {
      mode: Boolean,
      default: false,
    },
    ocItem: {
      mode: Array,
      required: false,
    },
    ocWorld: {
      mode: Array,
      required: false,
    },
    type: {
      mode: String,
      required: false,
    },
  },
  mounted() {
    this.getHeaderInfo();
    this.getMailHistoryBadge();
    this.setClass();
  },
  computed: {
    userClass() {
      //アカウント種別
      const admin = this.$store.state.adminFlag;
      const creator = this.$store.state.creatorFlag;
      const master = this.$store.state.masterFlag;
      const player = this.$store.state.playerFlag;
      if (admin === "1") {
        return "admin";
      } else if (creator === "1") {
        return "il";
      } else if (creator === "2") {
        return "va";
      } else if (creator === "3") {
        return "wr";
      } else if (master === "1") {
        return "ms";
      } else if (player === "1") {
        return "pl";
      } else {
        return null;
      }
    },
    userClassId() {
      //アカウント種別
      const admin = this.$store.state.adminFlag;
      const creator = this.$store.state.creatorFlag;
      const master = this.$store.state.masterFlag;
      const player = this.$store.state.playerFlag;
      if (admin === "1") {
        return "";
      } else if (creator === "1") {
        return this.$store.state.illustClassId;
      } else if (creator === "2") {
        return this.$store.state.voiceClassId;
      } else if (creator === "3") {
        return this.$store.state.writerClassId;
      } else if (master === "1") {
        return this.$store.state.masterId;
      } else if (player === "1") {
        return "";
      } else {
        return null;
      }
    },
    userClassIcon() {
      //アカウント種別
      const admin = this.$store.state.adminFlag;
      const creator = this.$store.state.creatorFlag;
      const master = this.$store.state.masterFlag;
      const player = this.$store.state.playerFlag;
      if (admin === "1") {
        return this.$store.state.userClassIcon;
      } else if (creator === "1") {
        return this.$store.state.illustClassIcon;
      } else if (creator === "2") {
        return this.$store.state.voiceClassIcon;
      } else if (creator === "3") {
        return this.$store.state.writerClassIcon;
      } else if (master === "1") {
        return this.$store.state.masterClassIcon;
      } else if (player === "1") {
        return this.$store.state.userClassIcon;
      } else {
        return null;
      }
    },
    userFlag() {
      let flag = [];
      flag.push(this.$store.state.adminFlag);
      flag.push(this.$store.state.creatorFlag);
      flag.push(this.$store.state.masterFlag);
      flag.push(this.$store.state.playerFlag);
      return flag;
    },
    userId() {
      if (this.$store.state.userId) {
        return this.$store.state.userId;
      } else {
        return null;
      }
    },
    mailBadge() {
      if (this.$store.state.mailHistoryBadge) {
        return this.$store.state.mailHistoryBadge;
      } else {
        return null;
      }
    },
  },
  watch: {
    // storeの名前・アイコンの更新
    "$store.state.userName"(to, from) {
      this.userName = this.$store.state.userName;
    },
    "$store.state.userIcon"(to, from) {
      this.userIcon = this.$store.state.userIcon;
      this.setClass();
    },
    "$store.state.lastUsedClass"(to, from) {
      this.lastUsedClass = this.$store.state.lastUsedClass;
    },
    // ルートが変わった際に呼び出されるメソッド
    $route(to, from) {
      this.getMailHistoryBadge();
    },
  },
  methods: {
    async getHeaderInfo() {
      if (this.userId != null) {
        this.loading = true;
        await this.getUserIconName();
        // TODO:使用していないので非表示
        // await this.getNoticeLists(val);
        this.loading = false;
      } else {
        this.userName = "";
        this.userIcon = "";
      }
    },
    setClass: function () {
      this.lastUsedClass = this.$store.state.lastUsedClass;

      this.classLists[0].name = this.$store.state.userClassName;
      this.classLists[0].creatorId = "";
      this.classLists[0].icon = this.$store.state.userClassIcon;

      this.classLists[1].name = this.$store.state.masterClassName;
      this.classLists[1].creatorId = this.$store.state.masterId
        ? this.$store.state.masterId
        : "";
      this.classLists[1].icon = this.$store.state.masterClassIcon;

      this.classLists[2].name = this.$store.state.illustClassName;
      this.classLists[2].creatorId = this.$store.state.illustClassId
        ? this.$store.state.illustClassId
        : "";
      this.classLists[2].icon = this.$store.state.illustClassIcon;

      this.classLists[3].name = this.$store.state.voiceClassName;
      this.classLists[3].creatorId = this.$store.state.voiceClassId
        ? this.$store.state.voiceClassId
        : "";
      this.classLists[3].icon = this.$store.state.voiceClassIcon;

      this.classLists[4].name = this.$store.state.writerClassName;
      this.classLists[4].creatorId = this.$store.state.writerClassId
        ? this.$store.state.writerClassId
        : "";
      this.classLists[4].icon = this.$store.state.writerClassIcon;

      this.classLists[5].name = this.$store.state.adminClassName;
      this.classLists[5].icon = this.$store.state.adminClassIcon;
      this.classLists[5].creatorId = "";
    },

    signOut() {
      this.$emit("signOut");
    },

    //ユーザーアイコンと名前をGET
    async getUserIconName() {
      if (this.$store.state.lastUsedClass) {
        if (this.$store.state.userName) {
          this.userName = this.$store.state.userName;
        }
        if (this.$store.state.userIcon) {
          this.userIcon = this.$store.state.userIcon;
        }
      } else {
        this.userName = this.$store.state.userClassName;
        this.userIcon = this.$store.state.userClassIcon;
      }
    },
    errorDialogReturn(answer) {
      if (answer) {
        //接続エラーあったらサインアップページへ
        this.signOut();
      }
    },

    getKoshinDate(noticeList) {
      var date = new Date(noticeList.koshinDate);
      var day = date.getDate();
      var month = date.getMonth();
      var year = date.getFullYear();
      var dateStr = year + "/" + month + "/" + day;
      return dateStr;
    },

    toNoticeLists() {
    },
    //headerにポータル新規お知らせをGET
    // async getNoticeLists() {
    //   const res = await axios.get(
    //     this.serverPath +
    //       "/api/GetNotice/getNoticeLists?pageStart=0" +
    //       "&pageEnd=4"
    //   );
    //   this.noticeLists = res.data;
    // },

    handleUserDropdown: function () {
      alert("button click");
    },

    toPortalTop: function () {
      this.$router.push("/");
    },

    toMyPage: function () {
      this.$router.push({
        name: "myPage",
      });
    },

    changeClass: async function (i) {
      // テーブル更新
      await this.updateLastUsedClass(i);
      // メイン使用データとして更新
      this.$store.dispatch("creatorId", {
        creatorId: this.classLists[i].creatorId,
      });
      this.$store.dispatch("userName", {
        userName: this.classLists[i].name,
      });
      this.$store.dispatch("userIcon", {
        userIcon: this.classLists[i].icon,
      });
      this.upload(true);

      setTimeout(() => {
        // const userClass = this.$store.state.lastUsedClass;
        if (/^myPage-.*$/.test(this.$route.name)) {
          this.$router.push({name: "myPage-home"}, () => {
          });
        }
        this.reload();
        this.upload(false);
      }, 1000);
    },
    updateLastUsedClass: async function (i) {
      axios({
        method: "post",
        url: this.serverPath + "/api/userClass/updateLastClass",
        data: "&userId=" + this.$store.state.userId + "&lastClass=" + Number(i),
      })
        .then(() => {
          // 更新成功でラストクラスを更新
          this.$store.dispatch("lastUsedClass", {
            lastUsedClass: i,
          });
          // storeフラグの更新
          this.changeflg(i);
          // 表示変更用にセット
          this.lastUsedClass = this.$store.state.lastUsedClass;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    changeflg(i) {
      // 権限の制御
      switch (i) {
        case 0: // user
          this.$store.dispatch("adminFlag", {
            adminFlag: "0",
          });
          this.$store.dispatch("playerFlag", {
            playerFlag: "1",
          });
          this.$store.dispatch("masterFlag", {
            masterFlag: "0",
          });
          this.$store.dispatch("creatorFlag", {
            creatorFlag: "0",
          });
          break;
        case 1: // master
          this.$store.dispatch("adminFlag", {
            adminFlag: "0",
          });
          this.$store.dispatch("playerFlag", {
            playerFlag: "0",
          });
          this.$store.dispatch("masterFlag", {
            masterFlag: "1",
          });
          this.$store.dispatch("creatorFlag", {
            creatorFlag: "0",
          });
          break;
        case 2:
          // IL
          this.$store.dispatch("adminFlag", {
            adminFlag: "0",
          });
          this.$store.dispatch("playerFlag", {
            playerFlag: "0",
          });
          this.$store.dispatch("masterFlag", {
            masterFlag: "0",
          });
          this.$store.dispatch("creatorFlag", {
            creatorFlag: "1",
          });
          break;
        case 3: // VA
          this.$store.dispatch("adminFlag", {
            adminFlag: "0",
          });
          this.$store.dispatch("playerFlag", {
            playerFlag: "0",
          });
          this.$store.dispatch("masterFlag", {
            masterFlag: "0",
          });
          this.$store.dispatch("creatorFlag", {
            creatorFlag: "2",
          });
          break;
        case 4: // WR
          this.$store.dispatch("adminFlag", {
            adminFlag: "0",
          });
          this.$store.dispatch("playerFlag", {
            playerFlag: "0",
          });
          this.$store.dispatch("masterFlag", {
            masterFlag: "0",
          });
          this.$store.dispatch("creatorFlag", {
            creatorFlag: "3",
          });
          break;
        case 5: // ADMIN
          this.$store.dispatch("adminFlag", {
            adminFlag: "1",
          });
          this.$store.dispatch("playerFlag", {
            playerFlag: "0",
          });
          this.$store.dispatch("masterFlag", {
            masterFlag: "0",
          });
          this.$store.dispatch("creatorFlag", {
            creatorFlag: "0",
          });
          break;
      }
    },
    openNotice: function () {
    },

    goSearchResult(event) {
      if (this.search && event.keyCode === 13) {
        this.$router.push({
          name: "portalSearchResult",
          params: {type: "all", keyword: this.search},
        });
        this.searchMenu = false;
        this.search = "";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/sass/import.scss";

.pHeader {
  a {
    color: var(--gray-8);

    &:hover {
      color: var(--gray-6);
    }
  }

  &-Nav {
    a,
    a:visited {
      color: var(--gray-8);
    }

    a:hover {
      color: var(--gray-6);
    }
  }

  &-Menu {
    z-index: $z-nav;
    background-color: var(--white);
    border: solid 1px var(--c-border);
  }
}
</style>
